<template>

    <span class="badges badges-bg badges-paid" v-if="props?.remaining_amount <= 0">
        {{ i18n.t('status.paid') }}
    </span>
    <span v-else class="badges badges-bg badges-unpaid">
        {{ i18n.t('status.unpaid') }}
    </span>

</template>
<script setup>
import { defineProps } from 'vue';
import i18n from '@/i18n/index'
const props = defineProps({
    remaining_amount: Number,

});


</script>